export const selectReducer = (state) => state.categories;

export const selectCategories = (state) =>
  selectReducer(state) ? selectReducer(state).get('category').categories : [];

export const selectIsLoading = (state) =>
  selectReducer(state) ? selectReducer(state).get('category').isLoading : false;
